export type BrandedVariables = {
  common: {
    borderRadius: number;
  };
  colors: {
    primary: {
      main: string;
      dark: string;
      contrastText: string;
    };
    secondary: {
      main: string;
      dark: string;
    };
    error: {
      main: string;
    };
    text: {
      primary: string;
      secondary: string;
      hint: string;
    };

    background: string;
    border: string;
    hover: string;
    placeholder: string;
    transparent: string;
  };
};

export function PrepareProperties(variables: BrandedVariables) {
  return {
    buttons: {
      boxShadow: "none",
    },
    inputs: {
      placeholder: {
        color: variables.colors.placeholder,
        opacity: 1,
      },
    },
    listItems: {
      root: {
        border: "1px solid " + variables.colors.transparent,
        borderLeftWidth: 2,
        "&$selected": {
          borderLeftColor: variables.colors.primary.main,
        },
      },
    },
  };
}

export function svgSelectorWrapper(
  svgBody: any,
  options: {
    svgRelation?: string;
    svgElement?: string;
    wrapInSVG?: boolean;
  } = {},
) {
  if (svgBody === undefined || svgBody === null) {
    return undefined;
  }

  options.wrapInSVG = options?.wrapInSVG ?? true;

  const innerResult: any = {};
  innerResult[`&> ${options?.svgElement ?? "path"}`] = svgBody;

  const wrappedResult: any = {};
  wrappedResult[`&${options?.svgRelation ?? ">"} svg`] = innerResult;

  return options?.wrapInSVG ? wrappedResult : innerResult;
}

export function svgClass(selector: string, body: any) {
  const obj: any = {};
  obj[`&${selector}`] = svgSelectorWrapper(body, { wrapInSVG: false });
  return obj;
}
